/** Icon-only tech logos (Webflow CDN) + labels for dark course marquees */
const WF_CDN =
  "https://cdn.prod.website-files.com/5fa61cbbf0d432b3230f62b1";

export const TECH_LOGO_ITEMS_DARK = {
  html: {
    id: "html",
    src: `${WF_CDN}/622c401a414f2658e0d70a3d_html-logo-2x.avif`,
    label: "HTML5",
  },
  css: {
    id: "css",
    src: `${WF_CDN}/622c41eb685365f62feaa5ca_css-logo-2x.avif`,
    label: "CSS3",
  },
  javascript: {
    id: "javascript",
    src: `${WF_CDN}/622c378c2d22170ffc6cc677_Javascript-logo.avif`,
    label: "JavaScript",
  },
  bootstrap: {
    id: "bootstrap",
    src: `${WF_CDN}/622c41eac36111f2ee1cee52_bootstrap-logo-2x.avif`,
    label: "BootStrap",
  },
  python: {
    id: "python",
    src: `${WF_CDN}/622c413591e4ae565aebe3ce_python-logo-2x.avif`,
    label: "Python",
  },
  react: {
    id: "react",
    src: `${WF_CDN}/622c41ed966d798861d97ca4_react-logo-2x.avif`,
    label: "React JS",
  },
  tailwind: {
    id: "tailwind",
    src: `${WF_CDN}/6a73090298657a1b5c0e7ee5_bootstrap%20(1).avif`,
    label: "Tailwindcss",
  },
  java: {
    id: "java",
    src: `${WF_CDN}/698b277310f0e4d8bedf5a1d_java%20(1).avif`,
    label: "Java",
  },
  springBoot: {
    id: "springBoot",
    src: `${WF_CDN}/6a730903fd207b1625d06f13_spring-boot.avif`,
    label: "Spring Boot",
  },
};

const T = TECH_LOGO_ITEMS_DARK;

/** Same stack order as light `COURSE_LOGOS` in CourseLogoMarquee */
export const COURSE_LOGOS_DARK = {
  mernUp: [T.html, T.css, T.javascript, T.bootstrap],
  mernDown: [T.python, T.react, T.tailwind],
  javaDown: [T.springBoot, T.java, T.tailwind],
  mobileFull: [
    T.html,
    T.css,
    T.javascript,
    T.bootstrap,
    T.python,
    T.tailwind,
    T.react,
  ],
  mobileJava: [
    T.javascript,
    T.java,
    T.tailwind,
    T.springBoot,
    T.html,
    T.css,
    T.bootstrap,
  ],
};
